export const CARTSTATES = {
  UPDATINGERROR: 'cartUpdatingError',
  UPDATED: 'cartUpdated',
  FORMSIZEERROR: 'formError',
  FORMINTERACTION: 'formInteraction',
  EXTERNALUPDATE: 'cartExternalUpdate',
}

export const THEME = {
  drawerControlInteraction: 'drawer:triggerInteraction',
  collectionMasterEvent: 'theme:collectionFilterEvent',
  customizerSelectEvent: 'theme:customizerSelectEvent',
  customizerDeselectEvent: 'theme:customizerDeselectEvent',
  modalControlInteraction: 'modal:triggerInteraction',
  userLocationIsSet: 'theme:userLocationIsSet',
}
